import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndInputDateTime from '../common/form/labelAndInputDateTime';
import Select from '../common/form/select';
import SelectAlteracao from '../common/form/selectAlteracao';
import LabelAndInputMask from '../common/form/labelAndInputMask';

import {
	setModoTela, initForm
} from './radiologistaActions';

class RadiologistaForm extends Component {

	state = {

	}

    componentWillMount() {

    }

    render() {

		let readOnly = this.props.excluir ? 'readOnly' : '';

		return (
			<ContentCard>
				<Form event={this.props.handleSubmit}>
					<ContentCardBody>
						<Row>

							<Field
								name='nome'
								component={LabelAndInput}
								label='Nome *' placeholder='Informe'
								cols='12 12 12 12'
								readOnly={readOnly} />

							<Field
								name='cpf'
								component={LabelAndInputMask}
								label='CPF *' placeholder='Informe'
								cols='12 6 4 3'
								readOnly={readOnly}
								mask={'999.999.999-99'}
								type='text' />

							<Field
								name='crm'
								component={LabelAndInputMask}
								label='CRM *' placeholder='Informe'
								cols='12 6 4 3'
								readOnly={readOnly}
								mask={'99999/AA'}
								type='text' />

							<Field
								name='telefone'
								component={LabelAndInputMask}
								label='Telefone' placeholder='Informe'
								cols='12 6 4 3'
								readOnly={readOnly}
								mask={'(99) 99999-9999'}
								type='text' />
							
							<Field
								name='email'
								component={LabelAndInput}
								label='E-mail' placeholder='Informe'
								cols='12 6 4 3'
								readOnly={readOnly}
								type='text' />
							
							<Field
								name='nome_banco'
								component={LabelAndInput}
								label='Banco' placeholder='Informe'
								cols='12 6 4 3'
								readOnly={readOnly} />
							
							<Field
								name='agencia_banco'
								component={LabelAndInput}
								label='Agência' placeholder='Informe'
								cols='12 6 4 3'
								readOnly={readOnly} />
							 
							<Field
								name='conta_banco'
								component={LabelAndInput}
								label='Conta' placeholder='Informe'
								cols='12 6 4 3'
								readOnly={readOnly} />
							
							<Field
								name='pix'
								component={LabelAndInput}
								label='Pix' placeholder='Informe'
								cols='12 6 4 3'
								readOnly={readOnly} />

						</Row>

					</ContentCardBody>
					<ContentCardFooter>
						<Row alignCenter>
							<Grid cols='6 6 4 3'>
								{this.props.excluir ? (
									<Button
										text='Excluir'
										submit type={'danger'}
										icon={'fa fa-trash'} />
								) : (
								<Button
									text='Salvar'
									submit
									type={'success'}
									icon={'fa fa-check'} />
								)}
							</Grid>
							<Grid cols='6 6 4 3'>
								<Button
									text='Voltar'
									type={'warning'}
									icon={'fa fa-chevron-left'}
									event={() => this.props.setModoTela('lista')} />
							</Grid>
						</Row>
					</ContentCardFooter>
				</Form>
			</ContentCard>
		);
    }


}

RadiologistaForm = reduxForm({form: 'radiologistaForm', destroyOnUnmount: false})(RadiologistaForm);
const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	formularioValues: getFormValues('radiologistaForm')(state),
	registro: state.radiologista.registro
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, initForm
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(RadiologistaForm);
